import { FC } from 'react'
import CustomerInfo from '../CustomerInfo/CustomerInfo'
import DepartureAndVesselInfo from '../DepartureAndVesselInfo/DepartureAndVesselInfo'
import RouteInfo from '../RouteInfo/RouteInfo'
import TicketItemsWithQR from '../TicketItemsWithQR/TicketItemsWithQR'
import { CustomerInfoProps, TicketPartProps } from '@/root/shared-types/reservation/reservation-types'
import { useGetTranslations } from '@/root/shared-hooks'

interface PrintedTicketPartProps extends TicketPartProps {
  cancelled: boolean
  reservationId: number
  cancelledByAdmin?: boolean
  customerInfo?: CustomerInfoProps
  hideQrCode?: boolean
}

const PrintedTicketPart: FC<PrintedTicketPartProps> = ({
  reservationId,
  vesselTitle,
  numOfPassengers,
  numOfCycles,
  sailRefId,
  items,
  departurePort,
  arrivalPort,
  departure,
  customerInfo,
  cancelled,
  cancelledByAdmin,
  hideQrCode,
  residents,
}) => {
  const { getTranslation } = useGetTranslations()

  return (
    <div className="ticket-print-avoid-break">
      {customerInfo && (
        <CustomerInfo
          customerEmail={customerInfo.email}
          customerName={customerInfo.fullName}
          customerPhoneNumber={customerInfo.phoneNumber}
          ticketNumber={reservationId}
        />
      )}
      <DepartureAndVesselInfo
        departure={departure || ''}
        vesselTitle={vesselTitle}
        numOfPassengers={numOfPassengers || 0}
        numOfCycles={numOfCycles || 0}
        cancelled={cancelled}
        cancelledByAdmin={cancelledByAdmin}
      />
      <RouteInfo arrivalPort={arrivalPort} departurePort={departurePort} />
      <TicketItemsWithQR items={items} reservationId={reservationId} sailRefId={sailRefId} hideQrCode={hideQrCode} />
      {Boolean(residents?.length) && (
        <div className="flex flex-col gap-4 border-t py-2 md:grid md:items-center md:gap-0">
          <p>{getTranslation('ticketLocalCustomers')}</p>
          <p>{residents?.map((r) => r.personalIdentificationNumber).join(', ')}</p>
        </div>
      )}
    </div>
  )
}

export default PrintedTicketPart
